<template>
  <div class="v-details-form">
    <div class="form__heading">
      <h2 class="form__title">{{ businessTitle }}</h2>
    </div>
    <div class="form__block">
      <ul v-if="website == 'athome'" class="form__list">
        <li class="form__item">
          <v-radios-public
            name="business_registration"
            :options="businessRadioOptions"
            :value="business_form_state"
            :label="businessLabel"
            @input="triggerBusinessForm"
            v-validate="`required|make_choice`"
          ></v-radios-public>
        </li>
      </ul>
    </div>
    <div id="business-form" v-if="business_form_state === '1'">
      <input
        type="hidden"
        name="business_registration"
        value="1"
        v-if="website == 'staffhousing'"
      />
      <ul class="form__list">
        <li class="form__item">
          <v-textfield-public
            :label="companyName"
            :name="companyNameInput"
            v-model="company_value"
            v-validate="`required`"
          ></v-textfield-public>
        </li>
        <template v-if="website == 'staffhousing'">
          <li class="form__item">
            <v-textfield-public
              :label="
                (locales &&
                  locales.subscriptions &&
                  locales.subscriptions.contact_person + ' ') +
                subscriptionsFirstName
              "
              :name="subscriptionsFirstNameInput"
              v-model="subscriptions_first_name_value"
              v-validate="`alpha_spaces_dash`"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              :label="
                (locales &&
                  locales.subscriptions &&
                  locales.subscriptions.contact_person + ' ') +
                subscriptionsMiddleName
              "
              :name="subscriptionsMiddleNameInput"
              v-model="subscriptions_middle_name_value"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              :label="
                (locales &&
                  locales.subscriptions &&
                  locales.subscriptions.contact_person + ' ') +
                subscriptionsLastName
              "
              :name="subscriptionsLastNameInput"
              v-model="subscriptions_last_name_value"
              v-validate="`alpha_spaces_dash`"
            ></v-textfield-public>
          </li>
        </template>
        <li class="form__item" v-else>
          <v-textfield-public
            :label="companyLegalForm"
            :name="companyLegalFormInput"
            v-model="company_legal_form_value"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            v-if="website == 'staffhousing'"
            :label="companyChamberOfCommerceNumber"
            :name="companyChamberOfCommerceNumberInput"
            v-model="company_chamber_of_commerce_number_value"
            v-validate="`alpha_num_spaces`"
          ></v-textfield-public>
          <v-textfield-public
            v-else
            :label="companyChamberOfCommerceNumber"
            :name="companyChamberOfCommerceNumberInput"
            v-model="company_chamber_of_commerce_number_value"
            v-validate="`alpha_num_spaces`"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            v-if="website == 'staffhousing'"
            :label="companyVatNumber"
            :name="companyVatNumberInput"
            v-model="company_vat_number_value"
            v-validate="`alpha_num_spaces`"
          ></v-textfield-public>
          <v-textfield-public
            v-else
            :label="companyVatNumber"
            :name="companyVatNumberInput"
            v-model="company_vat_number_value"
            v-validate="`alpha_num_spaces`"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <div class="form__row">
            <div class="form__column">
              <v-textfield-public
                :label="companyPostCode"
                :name="companyPostCodeInput"
                @blur="checkPcHnCompany($event)"
                v-model="company_post_code_value"
              ></v-textfield-public>
            </div>
            <div class="form__column">
              <v-textfield-public
                :label="companyHouseNumber"
                :name="companyHouseNumberInput"
                @blur="checkPostcodeAddressCompany($event)"
                v-model="company_house_number_value"
              ></v-textfield-public>
            </div>
          </div>
        </li>
        <li class="form__item">
          <v-textfield-public
            :label="companyStreet"
            :name="companyStreetInput"
            v-model="company_street_value"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            :label="companyCity"
            :name="companyCityInput"
            v-model="company_city_value"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            :label="companyCountry"
            :name="companyCountryInput"
            v-model="company_country_value"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            :label="companyPhoneNumber + ' (*)'"
            v-if="website == 'staffhousing'"
            :name="companyPhoneNumberInput"
            v-validate="`required|phone_number`"
            v-model="company_phone_number_value"
          ></v-textfield-public>
          <v-textfield-public
            :label="companyPhoneNumber"
            v-else
            :name="companyPhoneNumberInput"
            v-model="company_phone_number_value"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            :label="companyEmail + ' (*)'"
            v-if="website == 'staffhousing'"
            :name="companyEmailInput"
            v-validate="`required|email`"
            v-model="company_email_value"
          ></v-textfield-public>
          <v-textfield-public
            :label="companyEmail"
            v-else
            :name="companyEmailInput"
            v-model="company_email_value"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            :label="companyBankAccount"
            :name="companyBankAccountInput"
            v-model="company_bank_account_value"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            :label="companyBic"
            :name="companyBicInput"
            v-model="company_bic_value"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            :label="companyInvoiceEmail"
            :name="companyInvoiceEmailInput"
            v-model="company_invoice_email_value"
          ></v-textfield-public>
        </li>
      </ul>
    </div>
    <template v-if="website == 'athome'">
      <div class="form__heading">
        <h2 class="form__title">{{ subscriptionsIncome }}</h2>
      </div>
      <ul class="form__list">
        <li class="form__item">
          <v-checkboxes-public
            :label="subscriptionsIAm"
            :name="subscriptionsTypeOfIncomeInput"
            :options="subscriptionsTypeOfIncomeOptions"
            :values="subscriptions_type_of_income_value"
            @input="triggerIncomeAdditionalForms"
            v-validate="`required|make_choice`"
          ></v-checkboxes-public>
        </li>
        <!-- working or business -->
        <template v-if="income_form_work_business">
          <li class="form__item" v-if="income_form_work">
            <v-radios-public
              :label="usersContractType"
              :name="usersContractTypeInput"
              :options="usersContractTypeOptions"
              :value="usersContractTypeValue"
              @input="triggerContractDuration"
              v-validate="`required|make_choice`"
            ></v-radios-public>
          </li>
          <template v-if="showDuration && income_form_work">
            <li class="form__item">
              <v-textfield-public
                :label="usersContractDuration"
                :name="usersContractDurationInput"
                :value="usersContractDurationValue"
                v-validate="`required|numeric`"
              ></v-textfield-public>
            </li>
            <li class="form__item">
              <v-datepicker-public
                :label="usersContractEndDate"
                :name="usersContractEndDateInput"
                :value="usersContractEndDateValue"
                v-validate="`required`"
              ></v-datepicker-public>
            </li>
          </template>
          <li class="form__item">
            <v-textfield-public
              :label="usersOccupation"
              :name="usersOccupationInput"
              v-model="users_occupation_value"
              v-validate="`required`"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              :label="usersMonthlyIncome"
              :name="usersMonthlyIncomeInput"
              v-model="users_monthly_income_value"
              v-validate="`required|numeric`"
            ></v-textfield-public>
            <div class="form__bottom-row">{{ usersMonthlyIncomeNote }}</div>
          </li>
          <li class="form__item">
            <v-radios-public
              :label="usersDoYouHaveGuarantorGeneral"
              :name="usersDoYouHaveGuarantorInput"
              :options="usersDoYouHaveGuarantorOptions"
              :value="users_do_you_have_guarantor_value"
              @input="triggerGuarantorForm"
              v-validate="`make_choice`"
            ></v-radios-public>
          </li>
          <li v-if="guarantor_form_state == 1" class="form__item">
            <v-textfield-public
              :label="usersGuarantorIncome"
              :name="usersGuarantorIncomeInput"
              v-model="users_guarantor_income_value"
              v-validate="`numeric`"
            ></v-textfield-public>
          </li>
        </template>
        <!-- studying -->
        <template v-if="income_form_studying">
          <template v-if="!income_form_work_business">
            <li class="form__item">
              <v-radios-public
                :label="usersDoYouHaveGuarantor"
                :name="usersDoYouHaveGuarantorInput"
                :options="usersDoYouHaveGuarantorOptions"
                :value="users_do_you_have_guarantor_value"
                @input="triggerGuarantorForm"
                v-validate="`required|make_choice`"
              ></v-radios-public>
            </li>
            <!--<li v-if="guarantor_form_state == 0 || guarantor_form_state == 2" class="form__item">
						<v-radios-public 
							:label="usersDoYouHaveOtherGuaranteeOptions"
							:name="usersDoYouHaveOtherGuaranteeOptionsInput" 
							:options="usersDoYouHaveOtherGuaranteeOptionsOptions" 
							value="0"
							v-validate="`required|make_choice`">
						</v-radios-public>
            </li>-->
            <li v-if="guarantor_form_state == 1" class="form__item">
              <v-textfield-public
                :label="usersGuarantorIncome"
                :name="usersGuarantorIncomeInput"
                v-model="users_guarantor_income_value"
                v-validate="`required|numeric`"
              ></v-textfield-public>
            </li>
          </template>
          <li class="form__item">
            <v-textfield-public
              :label="usersStudy"
              :name="usersStudyInput"
              v-model="users_study_value"
              v-validate="`required`"
            ></v-textfield-public>
          </li>
        </template>
        <li v-if="income_form_any" class="form__item form__item--align-start">
          <label class="form__label">{{ usersExtraInformationIncome }}</label>
          <textarea
            class="form__textarea"
            :name="usersExtraInformationIncomeInput"
            v-model="usersIncomeNote"
          ></textarea>
        </li>
      </ul>
    </template>
    <div class="form__heading" v-if="website !== 'staffhousing'">
      <h2 class="form__title">{{ usersLandlordDetails }}</h2>
    </div>
    <ul class="form__list" v-if="website !== 'staffhousing'">
      <li class="form__item">
        <v-radios-public
          :label="usersLandlordLabel"
          :name="usersLandlordRadio"
          :options="usersLandlordOptions"
          v-model="landlord_type_state"
          @input="triggerLandlordType"
        ></v-radios-public>
      </li>
      <li v-if="landlord_type_state == 'renting_property'" class="form__item">
        <ul class="form__list">
          <li class="form__item">
            <v-textfield-public
              :label="usersLandlordNameLabel"
              :name="usersLandlordName"
              v-model="users_landlord_name_value"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              :label="usersLandlordEmailLabel"
              :name="usersLandlordEmail"
              v-model="users_landlord_email_value"
              v-validate="`email`"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              :label="usersLandlordPhoneLabel"
              :name="usersLandlordPhone"
              v-model="users_landlord_phone_value"
              v-validate="`phone_number`"
            ></v-textfield-public>
          </li>
        </ul>
      </li>
    </ul>
    <div class="form__heading" v-if="website !== 'staffhousing'">
      <h2 class="form__title">{{ subscriptionsYourDetails }}</h2>
    </div>
    <ul class="form__list" v-if="website !== 'staffhousing'">
      <li class="form__item form__item--no-label">
        <v-radios-public
          :name="subscriptionsSexInput"
          :options="subscriptionsSexOptions"
          :value="subscriptions_sex_value"
          v-validate="`required|make_choice`"
        ></v-radios-public>
      </li>
      <li class="form__item">
        <v-radios-public
          :label="locales && locales.users && locales.users.language"
          :value="defaultLanguage"
          name="languageInput"
          show-zero-option="0"
          :options="languages"
          v-validate="`required`"
        ></v-radios-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsFirstName"
          :name="subscriptionsFirstNameInput"
          v-model="subscriptions_first_name_value"
          v-validate="`required|alpha_spaces_dash`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsMiddleName"
          :name="subscriptionsMiddleNameInput"
          v-model="subscriptions_middle_name_value"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsLastName"
          :name="subscriptionsLastNameInput"
          v-model="subscriptions_last_name_value"
          v-validate="`required|alpha_spaces_dash`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :name="subscriptionsPostCode"
          :label="locales && locales.users && locales.users.post_code"
          @blur="checkPcHn($event)"
          class="js-postcode"
          v-model="subscriptions_post_code_value"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :name="subscriptionsHouseNumber"
          :label="locales && locales.users && locales.users.house_number"
          class="js-house-number"
          @blur="checkPostcodeAddress($event)"
          v-model="subscriptions_house_number_value"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :name="subscriptionsStreet"
          :label="locales && locales.users && locales.users.street"
          v-model="subscriptions_street_value"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :is-update-model="true"
          :name="subscriptionsCity"
          :label="locales && locales.users && locales.users.city"
          v-model="subscriptions_city_value"
        ></v-textfield-public>
      </li>
      <li class="form__item" v-if="website == 'athome'">
        <v-datepicker-public
          :label="subscriptionsDateOfBirth"
          :name="subscriptionsDateOfBirthInput"
          :value="subscriptions_date_of_birth_value"
          v-validate="`required`"
        ></v-datepicker-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsPhoneNumber"
          :name="subscriptionsPhoneNumberInput"
          v-model="subscriptions_phone_number_value"
          class="js-unique-phone"
          @blur="checkPhone"
          v-validate="`required|phone_number`"
        ></v-textfield-public>
      </li>
      <li class="form__item" v-if="!!is_phone_number_unique">
        <label class="form__label"></label>
        <b style="color: red">{{ phoneNumberAlreadyExists }}</b>
        <input
          type="hidden"
          name="phone_number_unique"
          v-validate="`required`"
        />
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsEmail"
          :name="subscriptionsEmailInput"
          v-model="subscriptions_email_value"
          class="js-unique-mail"
          @blur="checkMail"
          type="email"
          v-validate="`required|email`"
        ></v-textfield-public>
      </li>
      <li class="form__item" v-if="is_user_already_exists == 1">
        <label class="form__label"></label>
        <b style="color: red">{{ isUserAlreadyExists }}</b>
        <input
          type="hidden"
          name="user_already_exists"
          v-validate="`required`"
        />
      </li>
      <li class="form__item" v-if="is_user_already_exists == 2">
        <label class="form__label"></label>
        <b style="color: red">{{ isUserBanned }}</b>
        <input
          type="hidden"
          name="user_already_exists"
          v-validate="`required`"
        />
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsInvoiceEmail"
          :name="subscriptionsInvoiceEmailInput"
          v-model="subscriptions_invoice_email_value"
          type="email"
          v-validate="`email`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsBankAccount"
          :name="subscriptionsBankAccountInput"
          v-model="subscriptions_bank_account_value"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsBic"
          :name="subscriptionsBicInput"
          v-model="subscriptions_bic_value"
        ></v-textfield-public>
      </li>
      <template v-if="website == 'athome'">
        <li class="form__item">
          <v-select-public
            :label="subscriptionsCivilState"
            :value="subscriptions_civil_state_value"
            :name="subscriptionsCivilStateInput"
            show-zero-option="0"
            :options="subscriptionsCivilStateOptions"
            v-validate="`required`"
          ></v-select-public>
        </li>
        <li class="form__item">
          <v-select-public
            :label="subscriptionsSmoking"
            :value="subscriptions_smoking_value"
            name="smoking"
            :options="subscriptionsSmokingOptions"
            show-zero-option="0"
          ></v-select-public>
        </li>
        <li class="form__item">
          <v-select-public
            :label="subscriptionsPets"
            :value="subscriptions_pets_value"
            name="have_pets"
            :options="subscriptionsPetsOptions"
            show-zero-option="0"
            @input="triggerPetsForm"
          ></v-select-public>
        </li>
        <li class="form__item" v-if="subscriptions_pets_value == 1">
          <v-textfield-public
            :label="subscriptionsPetsNote"
            name="pets_note"
            v-model="subscriptions_pets_note_value"
            v-validate="`required`"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-select-public
            :label="subscriptionsChildren"
            :value="subscriptions_children_value"
            name="have_children"
            :options="subscriptionsChildrenOptions"
            show-zero-option="0"
            @input="triggerChildrenForm"
          ></v-select-public>
        </li>
        <li class="form__item" v-if="subscriptions_children_value == 1">
          <v-textfield-public
            :label="subscriptionsNumberOfChildren"
            name="number_of_children"
            v-model="subscriptions_number_of_children_value"
            type="number"
            v-validate="`required`"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            :label="subscriptionNumberOfAdults"
            name="number_of_adults"
            v-model.number="number_of_adults_value"
            v-validate="`required|numeric|min_value:0|max_value:5`"
          ></v-textfield-public>
        </li>
      </template>
    </ul>
    <div
      v-if="number_of_adults_value > 1 && website !== 'staffhousing'"
      v-for="adult in number_of_adults_value_computed - 1"
      :key="adult"
    >
      <v-details-inner-form
        :i="adult - 1"
        :extra-tenants="extra_tenants"
        :subscriptions="innerFormSubscriptions"
        :users-title-options="innerFormUsersTitleOptions"
        :users-first-name="subscriptionsFirstName"
        :users-middle-name="subscriptionsMiddleName"
        :users-last-name="subscriptionsLastName"
        :users-date-of-birth="subscriptionsDateOfBirth"
        :users-phone-number="companyPhoneNumber"
        :users-email="subscriptionsEmail"
        :users-invoice-email="subscriptionsInvoiceEmail"
        :users-bank-account="subscriptionsBankAccount"
        :users-bic="subscriptionsBic"
        :users-civil-state="subscriptionsCivilState"
        :users-civil-state-options="subscriptionsCivilStateOptions"
        :users-i-am="subscriptionsIAm"
        :users-type-of-income-options="subscriptionsTypeOfIncomeOptions"
        :users-type-of-income-slugs="subscriptionsTypeOfIncomeSlugs"
        :users-contract-type="usersContractType"
        :users-contract-type-options="usersContractTypeOptions"
        :users-contract-type-attributes="usersContractTypeAttributes"
        :users-contract-duration="usersContractDuration"
        :users-contract-end-date="usersContractEndDate"
        :users-occupation="usersOccupation"
        :users-monthly-income="usersMonthlyIncome"
        :users-monthly-income-note="usersMonthlyIncomeNote"
        :users-do-you-have-guarantor-general="usersDoYouHaveGuarantorGeneral"
        :users-do-you-have-guarantor-options="usersDoYouHaveGuarantorOptions"
        :users-do-you-have-other-guarantee-options="
          usersDoYouHaveOtherGuaranteeOptions
        "
        :users-do-you-have-other-guarantee-options-options="
          usersDoYouHaveOtherGuaranteeOptionsOptions
        "
        :users-guarantor-income="usersGuarantorIncome"
        :users-study="usersStudy"
        :users-extra-information-income="usersExtraInformationIncome"
        :income-form-all-states="incomeFormAllStates"
        :income-title="subscriptionsIncome"
        :users-landlord-options="usersLandlordOptions"
        :is-user-already-exists="isUserAlreadyExists"
        :is-user-banned="isUserBanned"
        :income-phone-number-already-exists="phoneNumberAlreadyExists"
        :languages="languages"
      ></v-details-inner-form>
    </div>
    <ul class="form__list">
      <li class="form__item" v-if="website !== 'staffhousing'">
        <input name="is_newsletter_subscriber" type="hidden" />
        <v-checkboxes-public
          :label="subscribeToNewsletter"
          class="form__radio"
          name="is_newsletter_subscriber"
          :options="{ '1': '' }"
          :value="isNewsletterSubscriberChecked"
          :checked="isNewsletterSubscriberChecked"
        ></v-checkboxes-public>
      </li>
      <li class="form__item">
        <button class="form__button" type="submit" @click.prevent="submitForm">
          {{ commonSend }}
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
import VTextfieldPublic from "./VTextfieldPublic";
import VDatepickerPublic from "./VDatepickerPublic.vue";
import sweetalert from "sweetalert";
import { mapGetters, mapActions } from "vuex";

export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
    VTextfieldPublic,
    VDatepickerPublic,
  },
  data() {
    return {
      income_form_any: false,
      income_form_studying: false,
      income_form_work: false,
      income_form_work_business: false,
      business_form_state: this.businessFormState,
      income_form_all_states: this.incomeFormAllStates,
      income_form_state: this.incomeFormState,
      guarantor_form_state: this.guarantorFormState,
      company_value: this.companyValue,
      company_legal_form_value: this.companyLegalFormValue,
      company_chamber_of_commerce_number_value: this
        .companyChamberOfCommerceNumberValue,
      company_vat_number_value: this.companyVatNumberValue,
      company_post_code_value: this.companyPostCodeValue,
      company_house_number_value: this.companyHouseNumberValue,
      company_street_value: this.companyStreetValue,
      company_city_value: this.companyCityValue,
      company_country_value: this.companyCountryValue,
      company_phone_number_value: this.companyPhoneNumberValue,
      company_email_value: this.companyEmailValue,
      company_invoice_email_value: this.companyInvoiceEmailValue,
      company_bank_account_value: this.companyBankAccountValue,
      company_bic_value: this.companyBicValue,
      subscriptions_type_of_income_value: this.subscriptionsTypeOfIncomeValue,
      users_occupation_value: this.usersOccupationValue,
      users_monthly_income_value: this.usersMonthlyIncomeValue,
      users_do_you_have_guarantor_value: this.usersDoYouHaveGuarantorValue,
      users_guarantor_income_value: this.usersGuarantorIncomeValue,
      users_study_value: this.usersStudyValue,
      subscriptions_sex_value: this.subscriptionsSexValue,
      subscriptions_first_name_value: this.subscriptionsFirstNameValue,
      subscriptions_middle_name_value: this.subscriptionsMiddleNameValue,
      subscriptions_last_name_value: this.subscriptionsLastNameValue,
      subscriptions_post_code_value: this.subscriptionsPostCodeValue,
      subscriptions_house_number_value: this.subscriptionsHouseNumberValue,
      subscriptions_city_value: this.subscriptionsCityValue,
      subscriptions_street_value: this.subscriptionsStreetValue,
      subscriptions_date_of_birth_value: this.subscriptionsDateOfBirthValue,
      subscriptions_phone_number_value: this.subscriptionsPhoneNumberValue,
      subscriptions_email_value: this.subscriptionsEmailValue,
      subscriptions_invoice_email_value: this.subscriptionsInvoiceEmailValue,
      subscriptions_bank_account_value: this.subscriptionsBankAccountValue,
      subscriptions_bic_value: this.subscriptionsBicValue,
      subscriptions_civil_state_value: this.subscriptionsCivilStateValue,
      subscriptions_smoking_value: this.subscriptionsSmokingValue,
      subscriptions_pets_value: this.subscriptionsPetsValue,
      subscriptions_pets_note_value: this.subscriptionsPetsNoteValue,
      subscriptions_children_value: this.subscriptionsChildrenValue,
      subscriptions_number_of_children_value: this
        .subscriptionsNumberOfChildrenValue,
      number_of_adults_value: this.subscriptionNumberOfAdultsValue,
      extra_tenants: this.extraTenants,
      landlord_type_state: this.landlordTypeState,
      users_landlord_name_value: this.usersLandlordNameValue,
      users_landlord_email_value: this.usersLandlordEmailValue,
      users_landlord_phone_value: this.usersLandlordPhoneValue,
      showDuration: false,
      is_user_already_exists: 0,
      is_phone_number_unique: 0,
    };
  },
  computed: {
    ...mapGetters(["locales"]),
    number_of_adults_value_computed: function () {
      if (this.number_of_adults_value >= 1) {
        return this.number_of_adults_value;
      } else {
        return 1;
      }
    },
    website: function () {
      if (this.websiteId != 2) {
        return "athome";
      } else {
        return "staffhousing";
      }
    },
  },
  props: {
    businessTitle: {
      default: "",
      type: String,
    },
    businessLabel: {
      default: "",
      type: String,
    },
    businessRadioOptions: {
      default: () => {},
      type: Object,
    },
    businessFormState: {
      default: "",
      type: String,
    },
    incomeFormAllStates: {
      default: () => [],
      type: Array,
    },
    incomeFormState: {
      default: () => [],
      type: Array,
    },
    guarantorFormState: {
      default: "",
      type: String,
    },
    companyName: {
      default: "",
      type: String,
    },
    companyNameInput: {
      default: "",
      type: String,
    },
    companyValue: {
      default: "",
      type: String,
    },
    companyLegalForm: {
      default: "",
      type: String,
    },
    companyLegalFormInput: {
      default: "",
      type: String,
    },
    companyLegalFormValue: {
      default: "",
      type: String,
    },
    companyChamberOfCommerceNumber: {
      default: "",
      type: String,
    },
    companyChamberOfCommerceNumberInput: {
      default: "",
      type: String,
    },
    companyChamberOfCommerceNumberValue: {
      default: "",
      type: String,
    },
    companyVatNumber: {
      default: "",
      type: String,
    },
    companyVatNumberInput: {
      default: "",
      type: String,
    },
    companyVatNumberValue: {
      default: "",
      type: String,
    },
    companyPostCode: {
      default: "",
      type: String,
    },
    companyPostCodeInput: {
      default: "",
      type: String,
    },
    companyPostCodeValue: {
      default: "",
      type: String,
    },
    companyHouseNumber: {
      default: "",
      type: String,
    },
    companyHouseNumberInput: {
      default: "",
      type: String,
    },
    companyHouseNumberValue: {
      default: "",
      type: String,
    },
    companyStreet: {
      default: "",
      type: String,
    },
    companyStreetInput: {
      default: "",
      type: String,
    },
    companyStreetValue: {
      default: "",
      type: String,
    },
    companyCity: {
      default: "",
      type: String,
    },
    companyCityInput: {
      default: "",
      type: String,
    },
    companyCityValue: {
      default: "",
      type: String,
    },
    companyCountry: {
      default: "",
      type: String,
    },
    companyCountryInput: {
      default: "",
      type: String,
    },
    companyCountryValue: {
      default: "",
      type: String,
    },
    companyPhoneNumber: {
      default: "",
      type: String,
    },
    companyPhoneNumberInput: {
      default: "",
      type: String,
    },
    companyPhoneNumberValue: {
      default: "",
      type: String,
    },
    companyEmail: {
      default: "",
      type: String,
    },
    companyEmailInput: {
      default: "",
      type: String,
    },
    companyEmailValue: {
      default: "",
      type: String,
    },
    companyInvoiceEmail: {
      default: "",
      type: String,
    },
    companyInvoiceEmailInput: {
      default: "",
      type: String,
    },
    companyInvoiceEmailValue: {
      default: "",
      type: String,
    },
    companyBankAccount: {
      default: "",
      type: String,
    },
    companyBankAccountInput: {
      default: "",
      type: String,
    },
    companyBankAccountValue: {
      default: "",
      type: String,
    },
    companyBic: {
      default: "",
      type: String,
    },
    companyBicInput: {
      default: "",
      type: String,
    },
    companyBicValue: {
      default: "",
      type: String,
    },
    subscriptionsIncome: {
      default: "",
      type: String,
    },
    subscriptionsIAm: {
      default: "",
      type: String,
    },
    subscriptionsTypeOfIncomeValue: {
      default: () => [],
      type: Array,
    },
    subscriptionsTypeOfIncomeInput: {
      default: "",
      type: String,
    },
    subscriptionsTypeOfIncomeOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsTypeOfIncomeSlugs: {
      default: () => {},
      type: Object,
    },
    userId: {
      default: null,
      type: Number,
    },
    usersContractType: {
      default: "",
      type: String,
    },
    usersContractTypeInput: {
      default: "",
      type: String,
    },
    usersContractTypeValue: {
      default: "",
      type: String,
    },
    usersContractTypeOptions: {
      default: () => {},
      type: [Object, Array],
    },
    usersContractTypeAttributes: {
      default: () => {},
      type: [Object, Array],
    },
    usersContractDuration: {
      default: "",
      type: String,
    },
    usersContractDurationInput: {
      default: "",
      type: String,
    },
    usersContractDurationValue: {
      default: "",
      type: String,
    },
    usersContractEndDate: {
      default: "",
      type: String,
    },
    usersContractEndDateInput: {
      default: "",
      type: String,
    },
    usersContractEndDateValue: {
      default: "",
      type: String,
    },
    usersOccupation: {
      default: "",
      type: String,
    },
    usersOccupationInput: {
      default: "",
      type: String,
    },
    usersOccupationValue: {
      default: "",
      type: String,
    },
    usersMonthlyIncome: {
      default: "",
      type: String,
    },
    usersMonthlyIncomeInput: {
      default: "",
      type: String,
    },
    usersMonthlyIncomeValue: {
      default: "",
      type: String,
    },
    usersMonthlyIncomeNote: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantor: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorGeneral: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorInput: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorOptions: {
      default: () => {},
      type: Object,
    },
    usersDoYouHaveGuarantorValue: {
      default: null,
      type: [Object, String],
    },
    usersDoYouHaveOtherGuaranteeOptions: {
      default: "",
      type: String,
    },
    usersDoYouHaveOtherGuaranteeOptionsInput: {
      default: "",
      type: String,
    },
    usersDoYouHaveOtherGuaranteeOptionsOptions: {
      default: () => {},
      type: Object,
    },
    usersGuarantorIncome: {
      default: "",
      type: String,
    },
    usersGuarantorIncomeInput: {
      default: "",
      type: String,
    },
    usersGuarantorIncomeValue: {
      default: "",
      type: String,
    },
    usersStudy: {
      default: "",
      type: String,
    },
    usersStudyInput: {
      default: "",
      type: String,
    },
    usersStudyValue: {
      default: "",
      type: String,
    },
    usersExtraInformationIncome: {
      default: "",
      type: String,
    },
    usersExtraInformationIncomeInput: {
      default: "",
      type: String,
    },
    usersIncomeNote: {
      default: "",
      type: String,
    },
    landlordTypeState: {
      default: "-1",
      type: String,
    },
    usersLandlordDetails: {
      default: "",
      type: String,
    },
    usersLandlordLabel: {
      default: "",
      type: String,
    },
    usersLandlordRadio: {
      default: "",
      type: String,
    },
    usersLandlordOptions: {
      default: () => {},
      type: Object,
    },
    usersLandlordNameLabel: {
      default: "",
      type: String,
    },
    usersLandlordEmailLabel: {
      default: "",
      type: String,
    },
    usersLandlordPhoneLabel: {
      default: "",
      type: String,
    },
    usersLandlordName: {
      default: "",
      type: String,
    },
    usersLandlordEmail: {
      default: "",
      type: String,
    },
    usersLandlordPhone: {
      default: "",
      type: String,
    },
    usersLandlordNameValue: {
      default: "",
      type: String,
    },
    usersLandlordEmailValue: {
      default: "",
      type: String,
    },
    usersLandlordPhoneValue: {
      default: "",
      type: String,
    },
    subscriptionsYourDetails: {
      default: "",
      type: String,
    },
    subscriptionsSexInput: {
      default: "",
      type: String,
    },
    subscriptionsSexOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsSexValue: {
      default: "",
      type: String,
    },
    subscriptionsFirstName: {
      default: "",
      type: String,
    },
    subscriptionsFirstNameInput: {
      default: "",
      type: String,
    },
    subscriptionsFirstNameValue: {
      default: "",
      type: String,
    },
    subscriptionsMiddleName: {
      default: "",
      type: String,
    },
    subscriptionsMiddleNameInput: {
      default: "",
      type: String,
    },
    subscriptionsMiddleNameValue: {
      default: "",
      type: String,
    },
    subscriptionsLastName: {
      default: "",
      type: String,
    },
    subscriptionsLastNameInput: {
      default: "",
      type: String,
    },
    subscriptionsLastNameValue: {
      default: "",
      type: String,
    },
    subscriptionsPostCode: {
      default: "",
      type: String,
    },
    subscriptionsPostCodeValue: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumber: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumberValue: {
      default: "",
      type: String,
    },
    subscriptionsStreet: {
      default: "",
      type: String,
    },
    subscriptionsStreetValue: {
      default: "",
      type: String,
    },
    subscriptionsCity: {
      default: "",
      type: String,
    },
    subscriptionsCityValue: {
      default: "",
      type: String,
    },
    subscriptionsDateOfBirth: {
      default: "",
      type: String,
    },
    subscriptionsDateOfBirthInput: {
      default: "",
      type: String,
    },
    subscriptionsDateOfBirthValue: {
      default: "",
      type: String,
    },
    subscriptionsPhoneNumber: {
      default: "",
      type: String,
    },
    subscriptionsPhoneNumberInput: {
      default: "",
      type: String,
    },
    subscriptionsPhoneNumberValue: {
      default: "",
      type: String,
    },
    subscriptionsEmail: {
      default: "",
      type: String,
    },
    subscriptionsEmailInput: {
      default: "",
      type: String,
    },
    subscriptionsEmailValue: {
      default: "",
      type: String,
    },
    subscriptionsInvoiceEmail: {
      default: "",
      type: String,
    },
    subscriptionsInvoiceEmailInput: {
      default: "",
      type: String,
    },
    subscriptionsInvoiceEmailValue: {
      default: "",
      type: String,
    },
    subscriptionsBankAccount: {
      default: "",
      type: String,
    },
    subscriptionsBankAccountInput: {
      default: "",
      type: String,
    },
    subscriptionsBankAccountValue: {
      default: "",
      type: String,
    },
    subscriptionsBic: {
      default: "",
      type: String,
    },
    subscriptionsBicInput: {
      default: "",
      type: String,
    },
    subscriptionsBicValue: {
      default: "",
      type: String,
    },
    subscriptionsCivilState: {
      default: "",
      type: String,
    },
    subscriptionsCivilStateInput: {
      default: "",
      type: String,
    },
    subscriptionsCivilStateOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsCivilStateValue: {
      default: "",
      type: String,
    },
    subscriptionsSmoking: {
      default: "",
      type: String,
    },
    subscriptionsSmokingValue: {
      default: "",
      type: String,
    },
    subscriptionsSmokingOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsPets: {
      default: "",
      type: String,
    },
    subscriptionsPetsOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsPetsValue: {
      default: "",
      type: String,
    },
    subscriptionsPetsNote: {
      default: "",
      type: String,
    },
    subscriptionsPetsNoteValue: {
      default: "",
      type: String,
    },
    subscriptionsChildren: {
      default: "",
      type: String,
    },
    subscriptionsChildrenValue: {
      default: "",
      type: String,
    },
    subscriptionsChildrenOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsNumberOfChildren: {
      default: "",
      type: String,
    },
    subscriptionsNumberOfChildrenValue: {
      default: "",
      type: String,
    },
    subscriptionNumberOfAdults: {
      default: "",
      type: String,
    },
    subscriptionNumberOfAdultsValue: {
      default: "",
      type: String,
    },
    extraTenants: {
      default: () => {},
      type: [Object, Array],
    },
    innerFormSubscriptions: {
      default: "",
      type: String,
    },
    innerFormUsersTitleOptions: {
      default: () => {},
      type: Object,
    },
    isNewsletterSubscriberChecked: {
      default: 0,
      type: Number,
    },
    commonSend: {
      default: "",
      type: String,
    },
    subscribeToNewsletter: {
      default: "",
      type: String,
    },
    websiteId: {
      default: "",
      type: String,
    },
    isUserAlreadyExists: {
      default: "",
      type: String,
    },
    isUserBanned: {
      default: "",
      type: String,
    },
    phoneNumberAlreadyExists: {
      default: "",
      type: String,
    },
    defaultLanguage: {
      default: "",
      type: String,
    },
    languages: {
      default: () => {},
      type: Object,
    },
    languageInput: {
      default: "",
      type: String,
    },
  },
  methods: {
    triggerBusinessForm: function (value) {
      this.business_form_state = value;
    },
    triggerPetsForm: function (value) {
      this.subscriptions_pets_value = value;
    },
    triggerChildrenForm: function (value) {
      this.subscriptions_children_value = value;
    },
    triggerIncomeAdditionalForms: function (value) {
      if (value) this.income_form_state = value;

      this.income_form_any = false;
      this.income_form_studying = false;
      this.income_form_work_business = false;
      this.income_form_work = false;

      for (var i = 0; i < this.income_form_state.length; i++) {
        var state = this.subscriptionsTypeOfIncomeSlugs[
          this.income_form_state[i]
        ];

        if (this.income_form_all_states.indexOf(state) > -1) {
          this.income_form_any = true;
          if (state == "own_business" || state == "working") {
            this.income_form_work_business = true;
          }
          if (state == "working") {
            this.income_form_work = true;
          }
          if (state == "studying") {
            this.income_form_studying = true;
          }
        }
      }
    },
    triggerContractDuration: function (value) {
      this.showDuration = false;
      if (value) {
        var option = this.usersContractTypeAttributes[value];
        if (option == "1") {
          this.showDuration = true;
        }
      } else {
        var option = this.usersContractTypeAttributes[
          this.usersContractTypeValue
        ];
        if (option == "1") {
          this.showDuration = true;
        }
      }
    },
    triggerGuarantorForm: function (value) {
      if (value !== true) {
        this.guarantor_form_state = value;
      } else {
        this.guarantor_form_state = -1;
      }
    },
    triggerLandlordType: function (value) {
      this.landlord_type_state = value;
    },
    submitForm: function (e) {
      e.preventDefault();
      this.$validator.validateAll().then((res) => {
        if (res) {
          let form = $("#form");
          let data = $("form").serialize();
          $.ajax({
            url: form.attr('action'),
            method: 'post',
            data: data,
            success: function (result) {
              if (result && result.status && result.status == "error") {
                var message = result.message;
                sweetalert(window.app.locales.common.error, message, "error");
              } else {
                sweetalert(
                  window.app.locales.common.success,
                  window.app.locales.common.success_update_details,
                  "success"
                ).then((res) => {
                  window.location.replace(result.url);
                });
              }
            },
            error: function (error) {
              if (error.status == 403 || error.status == 401) {
                sweetalert(
                  window.app.locales.common.error,
                  window.app.locales.common.login_required,
                  "error"
                ).then(() => {
                  window.location.reload();
                });
              } else {
                sweetalert(
                  window.app.locales.common.error,
                  window.app.locales.common.error,
                  "error"
                );
              }
            },
          });
				} else {
          let i,
            errorsMsg = "",
            errorsList = document.createElement("ol"),
            errorsListBox = document.createElement("div");

          errorsList.classList.add("custom-errors-list");

          for (i = 0; i < this.$validator.errors.items.length; i++) {
            errorsMsg += "<li>" + this.$validator.errors.items[i].msg + "</li>";
          }

          errorsList.innerHTML = errorsMsg;
          errorsListBox.innerHTML =
            '<strong class="custom-errors-list__subtitle">The form contain some errors:</strong>';
          errorsListBox.appendChild(errorsList);

          sweetalert({
            title: "Opps!",
            content: errorsListBox,
            icon: "error",
          });
        }
      });
    },
    checkMail: function (event) {
      var email = event.target.value;
      if (email == "") return (this.is_user_already_exists = 0);
      var vm = this;

      $.ajax({
        url: `/api/users/check-mail`,
        method: "post",
        data: {
          email: email,
          id: vm.userId,
        },
        success: function (result) {
          vm.is_user_already_exists = +result;
          if (result == 0) {
            var elements = document.getElementsByClassName("js-unique-mail");
            var mails = [];
            Array.prototype.forEach.call(elements, function (el) {
              // Do stuff here
              let val = el.querySelector("input").value;
              if (el.querySelector("input") != event.target && val != "") {
                mails.push(val);
              }
            });
            if (mails.length && mails.indexOf(email) != -1) {
              vm.is_user_already_exists = 1;
            } else {
              vm.is_user_already_exists = 0;
            }
          }
        },
        error: function () {},
      });
    },
    checkPhone: function (event) {
      var phone = event.target.value;
      if (phone == "") return (this.is_phone_number_unique = 0);
      var vm = this;
      var elements = document.getElementsByClassName("js-unique-phone");
      var phones = [];
      Array.prototype.forEach.call(elements, function (el) {
        // Do stuff here
        let val = el.querySelector("input").value;
        if (el.querySelector("input") != event.target && val != "") {
          phones.push(val);
        }
      });
      if (phones.length && phones.indexOf(phone) != -1) {
        vm.is_phone_number_unique = 1;
      } else {
        vm.is_phone_number_unique = 0;
      }
    },
    checkPcHn(event) {
      this.validated = false;
      this.changed = true;
      var that = this;
      setTimeout(function () {
        var postcode = $("[name='" + that.subscriptionsPostCode + "']")
          .first()
          .val();
        var house_number = $("[name='" + that.subscriptionsHouseNumber + "']")
          .first()
          .val();
        if (postcode && postcode != "") {
          $.post(
            "/get-street-location",
            {
              postcode: postcode,
              house_number: house_number,
            },
            function (data) {
              if (data.error == "false") {
                $("[name='" + that.subscriptionsCity + "']")
                  .first()
                  .val(data.location);
                that.subscriptions_city_value = data.location;
                $("[name='" + that.subscriptionsStreet + "']")
                  .first()
                  .val(data.street);
                that.subscriptions_street_value = data.street;
              }
            },
            "json"
          );
        }
      }, 100);
    },
    checkPostcodeAddress(event) {
      this.validated = false;
      this.changed = true;
      var that = this;
      setTimeout(function () {
        var street = $("[name='" + that.subscriptionsStreet + "']")
          .first()
          .val();
        var house_number = $("[name='" + that.subscriptionsHouseNumber + "']")
          .first()
          .val();
        var location = $("[name='" + that.subscriptionsCity + "']")
          .first()
          .val();
        if (street != "" && house_number != "") {
          $.post(
            `/get-postcode-by-address`,
            {
              street: street,
              house_number: house_number,
              location: location,
            },
            function (data) {
              if (data.error == "false") {
                $("[name='" + that.subscriptionsPostCode + "']")
                  .first()
                  .val(data.postcode);
                  that.subscriptions_post_code_value = data.postcode;
              }
            },
            "json"
          );
        }
      }, 100);
    },
    checkPcHnCompany(event) {
        this.validated = false;
        this.changed = true;
        var that = this;
        setTimeout(function () {
          var postcode = that.company_post_code_value;
          var house_number =that.company_house_number_value;
          if (postcode && postcode != "") {
            $.post(
              "/get-street-location",
              {
                postcode: postcode,
                house_number: house_number,
              },
              function (data) {
                if (data.error == "false") {
                  that.company_street_value = data.street;
                  that.company_city_value = data.location;
                }
              },
              "json"
            );
          }
        }, 100);
      },
      checkPostcodeAddressCompany(event) {
        this.validated = false;
        this.changed = true;
        var that = this;
        setTimeout(function () {
          var street = that.company_street_value;
          var house_number = that.company_house_number_value;
          var location = that.company_city_value;
          if (street != "" && house_number != "") {
            $.post(
              `/get-postcode-by-address`,
              {
                street: street,
                house_number: house_number,
                location: location,
              },
              function (data) {
                if (data.error == "false") {
                    that.company_post_code_value = data.postcode;
                }
              },
              "json"
            );
          }
        }, 100);
      },
    },
    beforeMount() {
      this.triggerIncomeAdditionalForms();
      this.triggerContractDuration();
    },
};
</script>